import "@shoelace-style/shoelace/dist/components/icon-button/icon-button.js";

import { css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { Style } from "./Styles";
import { BaseElement } from "./BaseElement";

import "./CloseButton";
import { litIf } from "./LitUtils";

@customElement("ds-fullscreen-window")
export class FullScreenWindow extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: block;
            }

            .overlay {
                position: fixed;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                background-color: rgba(0, 0, 0, 0.7);
            }

            .container {
                position: absolute;
                width: 100%;
                height: 100%;
                z-index: 850;
                background-color: #000000d4;
                left: 0px;
                top: 0px;
                /* padding: 1em; */
            }

            ds-close-button {
                position: absolute;
                right: 1em;
                top: 1em;
            }
        `,
    ];
    @property({ type: String }) propName: any;
    @property({ type: Boolean }) hideCloseButton = false;

    override render() {
        return html` <div class="overlay"></div>
            <div class="container" part="container">
                <slot></slot>
                ${litIf(!this.hideCloseButton, () => html`<ds-close-button></ds-close-button>`)}
            </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-fullscreen-window": FullScreenWindow;
    }
}
